import { useMemo } from "react";
import { URLSearchParamsInit, ParamKeyValuePair } from "@amzn/xb-hooks";

// Ripped from ReactRouter - reference: https://github.com/remix-run/react-router/blob/89049ce4ee1b265b78468f25eb494eef240a7e40/packages/react-router-dom/dom.ts#L76
export const createSearchParams = (init: URLSearchParamsInit = ""): URLSearchParams => {
  return new URLSearchParams(
    typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams
      ? init
      : Object.keys(init).reduce((memo, key) => {
          const value = init[key];
          return memo.concat(Array.isArray(value) ? value.map((v) => [key, v]) : [[key, value]]);
        }, [] as ParamKeyValuePair[]),
  );
};

export const useSearchParams = (): URLSearchParams => {
  const search = window.location.search;
  const searchParams = useMemo(() => createSearchParams(search), [search]);
  return searchParams;
};
